function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: "0"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".3",
  d: "M10 3.333A6.676 6.676 0 003.333 10 6.675 6.675 0 0010 16.667 6.675 6.675 0 0016.667 10 6.675 6.675 0 0010 3.333zm.834 10.834H9.167v-5h1.667v5zm0-6.667H9.167V5.833h1.667V7.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.166 5.833h1.667V7.5H9.166V5.833zm0 3.333h1.667v5H9.166v-5zm.834-7.5A8.336 8.336 0 001.667 10c0 4.6 3.733 8.333 8.333 8.333S18.333 14.6 18.333 10 14.6 1.667 10 1.667zm0 15A6.676 6.676 0 013.333 10 6.676 6.676 0 0110 3.333 6.676 6.676 0 0116.666 10 6.676 6.676 0 0110 16.666z"
}));